module.exports = __webpack_public_path__ + "static/media/mid.5efe0dde.svg";